import React from "react";
import {
  DashboardIcon,
  OrganizationIcon,
  UserIcon,
  BudgetIcon,
  CategoriesIcon,
  DataElementIcon,
  ReportsIcon,
  DataReviewIcon,
  RequestsIcon,
  SubmissionIcon,
} from "../icons/icons";

// ******* for business admin **************** //
export const sidebarMenuList = [
  {
    id: 1,
    roleId: [1],
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    roleId: [1],
    name: "Organizations",
    path: "/admin/organizations",
    icon: OrganizationIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Users",
    path: "/admin/users",
    icon: UserIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Budgets",
    path: "/admin/budgets",
    icon: BudgetIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Categories",
    path: "/admin/categories",
    icon: CategoriesIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Data Elements",
    path: "/admin/data-elements",
    icon: DataElementIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Reports",
    path: "/admin/reports",
    icon: ReportsIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Data Review",
    path: "/admin/data-review",
    icon: DataReviewIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Requests",
    path: "/admin/requests",
    icon: RequestsIcon(),
  },
  {
    id: 2,
    roleId: [1],
    name: "Submission Status",
    path: "/admin/submission-status",
    icon: SubmissionIcon(),
  },
  // {
  //   id: 2,
  //   roleId: [1],
  //   name: "Settings",
  //   path: "/admin/settings",
  //   icon: SetupIcon(),
  // },
  // {
  //   id: 2,
  //   roleId: [1],
  //   name: "Account",
  //   path: "/admin/account/profile",

  // },
];

// ******* for User **************** //
export const sidebarMenuListForOrgLeader = [
  {
    id: 1,
    roleId: [2, 3],
    name: "Dashboard",
    path: "/leader/dashboard",
    icon: <DashboardIcon />,
  },
  // {
  //   id: 2,
  //   roleId: [2, 3],
  //   name: "My Organization",
  //   path: "/leader/view-organization",
  //   icon: OrganizationIcon(),
  // },
  {
    id: 2,
    roleId: [2, 3],
    name: "Organization",
    path: "/leader/organizations",
    icon: OrganizationIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Users",
    path: "/leader/users",
    icon: UserIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Budgets",
    path: "/leader/budgets",
    icon: BudgetIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Data Elements",
    path: "/leader/data-elements",
    icon: DataElementIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Reports",
    path: "/leader/reports",
    icon: ReportsIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Data Review",
    path: "/leader/data-review",
    icon: DataReviewIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Submission Status",
    path: "/leader/submission-status",
    icon: SubmissionIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Data Entry",
    path: "/leader/data-entry",
    icon: ReportsIcon(),
  },
];

export const sidebarMenuListForOrgController = [
  {
    id: 1,
    roleId: [2, 3],
    name: "Dashboard",
    path: "/controller/dashboard",
    icon: <DashboardIcon />,
  },
  // {
  //   id: 2,
  //   roleId: [2, 3],
  //   name: "My Organization",
  //   path: "/controller/view-organization",
  //   icon: OrganizationIcon(),
  // },
  {
    id: 2,
    roleId: [2, 3],
    name: "Organization",
    path: "/controller/organizations",
    icon: OrganizationIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Users",
    path: "/controller/users",
    icon: UserIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Budgets",
    path: "/controller/budgets",
    icon: BudgetIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Data Elements",
    path: "/controller/data-elements",
    icon: DataElementIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Reports",
    path: "/controller/reports",
    icon: ReportsIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Data Review",
    path: "/controller/data-review",
    icon: DataReviewIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Submission Status",
    path: "/controller/submission-status",
    icon: SubmissionIcon(),
  },
  {
    id: 2,
    roleId: [2, 3],
    name: "Data Entry",
    path: "/controller/data-entry",
    icon: ReportsIcon(),
  },
];

// *********** User sidemenu list *************** //
export const sidebarMenuListForUser = [
  {
    id: 1,
    roleId: [4],
    name: "Dashboard",
    path: "/dashboard",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    roleId: [4],
    name: "Organization",
    path: "/organizations",
    icon: OrganizationIcon(),
  },
  {
    id: 2,
    roleId: [4],
    name: "Data Elements",
    path: "/data-elements",
    icon: DataElementIcon(),
  },
  // {
  //   id: 2,
  //   roleId: [4],
  //   name: "Reports",
  //   path: "/reports",
  //   icon: ReferralIcon(),
  // },
  {
    id: 2,
    roleId: [4],
    name: "Data Entry",
    path: "/data-entry",
    icon: ReportsIcon(),
  },
];
